module.exports = {"230506001":"红旗街道","230506002":"跃进街道","230506003":"东保卫街道","230506004":"七星街道","230506005":"双阳街道","230506006":"新安街道","230506007":"电厂街道","230506008":"农场街道","230506101":"七星镇","230506401":"双鸭山林业局宝山经营所","230506402":"双鸭山林业局大叶沟林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230506.json
// module id = 815
// module chunks = 0